module.exports = __webpack_public_path__ + "static/media/key.abcd1e04.svg";